import React from 'react';
const bonuses = [{
  title: 'Race Day Success System™',
  description: 'Everything you need to prepare athletes before, during, and after competition.'
}, {
  title: 'Running Strength Blueprint™',
  description: 'A complete strength training system specifically designed for runners.'
}, {
  title: 'Trail Running Coach Toolkit™',
  description: 'The essential guide to coaching trail runners and off-road endurance athletes.'
}, {
  title: 'Runner Nutrition Playbook™',
  description: 'Practical nutrition and hydration strategies for better performance and recovery.'
}, {
  title: 'Social Media For Running Coaches™',
  description: 'Content ideas, post templates, and client attraction systems for growing your coaching business.'
}];
const benefits = [{
  emoji: '⚡',
  title: 'Save Hours Every Week',
  desc: 'Stop creating workouts from scratch. Open the system, choose the framework, and start coaching immediately.'
}, {
  emoji: '👑',
  title: 'Greater Coaching Confidence',
  desc: 'Know exactly what to coach, when to progress athletes, and how to structure programs for maximum results.'
}, {
  emoji: '🏃',
  title: 'Better Athlete Results',
  desc: 'Deliver structured training systems that improve performance, consistency, and race outcomes.'
}, {
  emoji: '😊',
  title: 'Higher Athlete Retention',
  desc: 'Keep runners motivated through clear progressions, professional coaching systems, and visible improvements.'
}];
export function BonusSection() {
  return <>
      <section className="py-12 px-4 sm:px-6 bg-brand-paper" data-id="element-15">
        <div className="text-center mb-10" data-id="element-16">
          <h2 className="text-2xl sm:text-3xl font-heading font-black text-brand-navy mb-3 uppercase leading-tight" data-id="element-17">
            5 PREMIUM BONUSES INCLUDED
          </h2>
          <p className="text-sm sm:text-base font-bold text-brand-orange leading-snug max-w-2xl mx-auto" data-id="element-18">
            Plus, you'll receive 5 premium bonuses designed to save even more
            time and help your athletes perform at a higher level.
          </p>
        </div>

        <div className="flex flex-col gap-4 mb-8 max-w-3xl mx-auto" data-id="element-19">
          {bonuses.map((bonus, i) => <div key={i} className="bg-white border-2 border-brand-gold p-5 rounded-lg text-center shadow-md relative overflow-hidden" data-id="element-20">
              <div className="absolute top-0 left-0 w-full h-1.5 bg-brand-gold" data-id="element-21" />
              <p className="text-[11px] font-black text-brand-gold mb-2 tracking-widest uppercase" data-id="element-22">
                🎁 BONUS {i + 1}
              </p>
              <h3 className="text-base font-bold text-brand-navy mb-2 leading-tight uppercase" data-id="element-23">
                {bonus.title}
              </h3>
              <p className="text-sm text-brand-ink/70 leading-relaxed" data-id="element-24">
                {bonus.description}
              </p>
            </div>)}
        </div>
      </section>

      <section className="py-12 px-4 sm:px-6 bg-white border-y-4 border-brand-navy" data-id="element-25">
        <h2 className="text-2xl sm:text-3xl font-heading font-black text-center text-brand-navy mb-3 uppercase leading-tight" data-id="element-26">
          WHAT IS GOING TO CHANGE
        </h2>

        <div className="flex flex-col gap-4 max-w-3xl mx-auto mt-8" data-id="element-27">
          {benefits.map((item, i) => <div key={i} className="bg-brand-paper border-l-4 border-brand-teal p-5 rounded-r-lg shadow-sm flex gap-4 items-start" data-id="element-28">
              <div className="text-3xl shrink-0 leading-none mt-0.5" data-id="element-29">
                {item.emoji}
              </div>
              <div data-id="element-30">
                <h3 className="text-base font-bold text-brand-navy mb-1.5 uppercase tracking-tight" data-id="element-31">
                  {item.title}
                </h3>
                <p className="text-brand-ink/70 text-sm leading-relaxed" data-id="element-32">
                  {item.desc}
                </p>
              </div>
            </div>)}
        </div>
      </section>
    </>;
}